// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referral-services-form-footer .case-footer-buttons,.referral-services-form-footer .referral-footer-buttons{float:right}", ""]);
// Exports
module.exports = exports;
